// apps/web/src/components/estoque/campo-estoque-minimo.tsx — Fase 16.1, Plano 03 (D-22, UI-27).
// Campo opcional "Estoque mínimo ({unidade})" do fieldset "Estoque e compras" do material. Escrito com os componentes
// de `components/ui` e classes semânticas (verificador de estilo da Fase 16); os campos vizinhos do formulário não mudam.
import { FormMessage } from '../ui/form-message';
import { Input } from '../ui/input';
import { Label } from '../ui/label';

export const ID_CAMPO_ESTOQUE_MINIMO = 'materialEstoqueMinimo';
const ID_AJUDA = 'materialEstoqueMinimoAjuda';

export const TEXTO_AJUDA_ESTOQUE_MINIMO =
  'Opcional. Quando o saldo próprio da Pieltec, somado em todas as localizações, ficar abaixo deste valor, o material aparece no painel de Compras. Material de cliente não conta. Deixe em branco para não acompanhar.';

export interface CampoEstoqueMinimoProps {
  /** Unidade de estoque do material (vem de `parametros.unidadeEstoque`). */
  readonly unidade: string;
  /** Valor como digitado (vírgula ou ponto). Vazio = sem mínimo. */
  readonly valor: string;
  readonly erro: string | null;
  readonly desabilitado: boolean;
  readonly onChange: (valor: string) => void;
}

export function CampoEstoqueMinimo({ unidade, valor, erro, desabilitado, onChange }: CampoEstoqueMinimoProps) {
  const rotulo = unidade.trim() === '' ? 'Estoque mínimo' : `Estoque mínimo (${unidade.trim()})`;
  return (
    <div className="flex w-full flex-col gap-2">
      <Label htmlFor={ID_CAMPO_ESTOQUE_MINIMO}>{rotulo}</Label>
      <Input
        id={ID_CAMPO_ESTOQUE_MINIMO}
        type="text"
        inputMode="decimal"
        placeholder="Opcional"
        autoComplete="off"
        value={valor}
        disabled={desabilitado}
        aria-describedby={ID_AJUDA}
        aria-invalid={erro ? true : undefined}
        onChange={(evento) => onChange(evento.target.value)}
      />
      <p id={ID_AJUDA} className="text-sm text-muted-foreground">
        {TEXTO_AJUDA_ESTOQUE_MINIMO}
      </p>
      {erro ? <FormMessage>{erro}</FormMessage> : null}
    </div>
  );
}
